export const whenActiveTabChanges = (store, tab) => {
  if (tab === 'fans-list') {
    store.getFansList();
  }
};
